module.exports = __webpack_public_path__ + "static/media/gift-icon.ce6b14d2.png";